import { apiUrl } from "../lib/api";
import type { WorkspaceListItem } from "./api";

export interface WorkspaceSession {
  email: string;
  workspaces: WorkspaceListItem[];
}

export class WorkspaceSessionError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "WorkspaceSessionError";
  }
}

export async function fetchWorkspaceSession(): Promise<WorkspaceSession> {
  const meResponse = await fetch(apiUrl("/auth/me"), {
    credentials: "include",
  });
  if (!meResponse.ok) {
    throw new WorkspaceSessionError(
      meResponse.status,
      "Couldn't confirm your session. Try signing in again.",
    );
  }
  const me = (await meResponse.json()) as { userId: string };

  const workspacesResponse = await fetch(apiUrl("/workspaces"), {
    credentials: "include",
  });
  if (!workspacesResponse.ok) {
    throw new WorkspaceSessionError(
      workspacesResponse.status,
      "Couldn't load your workspaces. Please try again.",
    );
  }
  const { workspaces } = (await workspacesResponse.json()) as {
    workspaces: WorkspaceListItem[];
  };
  return { email: me.userId, workspaces };
}

export async function requestWorkspaceLogout(): Promise<string | undefined> {
  const response = await fetch(apiUrl("/auth/logout"), {
    method: "POST",
    credentials: "include",
  });
  if (!response.ok) return undefined;
  const body = (await response.json()) as { logoutUrl?: string };
  return typeof body.logoutUrl === "string" && body.logoutUrl.length > 0
    ? body.logoutUrl
    : undefined;
}
